/*
Copyright 2026 Element Creations Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { type FC } from "react";
import classNames from "classnames";
import { MicOnSolidIcon } from "@vector-im/compound-design-tokens/assets/web/icons";

import styles from "./ParticipantPill.module.css";

interface Props {
  name: string;
  /** Whether this participant is the current active speaker. */
  speaking?: boolean;
  className?: string;
}

/**
 * A small pill showing a participant's name, used in the call header's
 * "in call with" row and the in-call tile name tags. Highlights navy with a
 * mic glyph when the participant is the active speaker.
 */
export const ParticipantPill: FC<Props> = ({ name, speaking, className }) => (
  <span
    className={classNames(styles.pill, className, {
      [styles.speaking]: speaking,
    })}
  >
    {speaking && <MicOnSolidIcon width={16} height={16} aria-hidden />}
    {name}
  </span>
);
